const mutations = {
  mutationCommissionFromInsuranceTransactionDetailQuotation(state, payload) {
    state.quotation = payload;
  },

  mutationCommissionFromInsuranceTransactionDetailQuotationList(
    state,
    payload,
  ) {
    if (payload && (payload.tab || payload.tab === 0)) {
      state.quotationList[payload.tab] = payload.responseData;
    } else {
      state.quotationList = payload;
    }
  },

  mutationCommissionFromInsuranceTransactionDetailQuotationListMeta(
    state,
    payload,
  ) {
    state.quotationListMeta = payload;
  },
};

export default mutations;
